import { get, post, patch, del, json } from './apiClient';

export interface SubscriptionPlanPayload {
  name: string;
  price: string;
  description?: string;
  features?: string[];
  buttonText?: string;
  buttonColor?: string;
  isActive?: boolean;
  isPopular?: boolean;
}

export async function listSubscriptionPlans(bearer?: string | null) {
  const res = await get<any>('/api/admin/subscription-plans', { soft: true, headers: bearer ? { Authorization: `Bearer ${bearer}` } : undefined });
  return Array.isArray(res.data) ? res.data : [];
}

export async function createSubscriptionPlan(plan: SubscriptionPlanPayload, bearer?: string | null) {
  const res = await post<any>('/api/admin/subscription-plans', json(plan), { soft: true, headers: bearer ? { Authorization: `Bearer ${bearer}` } : undefined });
  return res.data;
}

export async function updateSubscriptionPlan(id: string, plan: Partial<SubscriptionPlanPayload>, bearer?: string | null) {
  const res = await patch<any>(`/api/admin/subscription-plans/${encodeURIComponent(id)}`, json(plan), { soft: true, headers: bearer ? { Authorization: `Bearer ${bearer}` } : undefined });
  return res.data;
}

export async function deleteSubscriptionPlan(id: string, bearer?: string | null) {
  const res = await del<any>(`/api/admin/subscription-plans/${encodeURIComponent(id)}`, { soft: true, headers: bearer ? { Authorization: `Bearer ${bearer}` } : undefined });
  return res.data;
}
